module.exports = __webpack_public_path__ + "img/stellini_brand_logo.8ab78ef6.png";